const locations = [...document.querySelectorAll('.js-location')];
const API = 'https://maps.googleapis.com/maps/api/js?key=';
const libraries = '&libraries=places';
const googleMapsSelector = '.js-googlemap';
const markers = [];

export const init = () => {
  const googleMaps = [...document.querySelectorAll(googleMapsSelector)];
  const timeOut = 500;
  if (googleMaps.length) {
    loadAPI();
    setTimeout(function () {
      initMap();
    }, timeOut);
  }
};

function initMap() {
  const googleMaps = [...document.querySelectorAll(googleMapsSelector)];

  if (googleMaps.length) {
    googleMaps.forEach(googleMap => {
      const mapMarker = {
        lat: parseFloat(googleMap.dataset.lat),
        lng: parseFloat(googleMap.dataset.lng),
      };

      // Map
      const map = new google.maps.Map(googleMap.querySelector('.js-map'), {
        center: mapMarker,
        zoom: parseInt(googleMap.dataset.zoom),
        mapTypeControl: false,
        streetViewControl: false,
        styles: JSON.parse(googleMap.dataset.styles),
      });

      // Create a bounding box with sides ~10km away from the center point
      const widthAwayFromCenter = 0.1;
      const defaultBounds = {
        north: mapMarker.lat + widthAwayFromCenter,
        south: mapMarker.lat - widthAwayFromCenter,
        east: mapMarker.lng + widthAwayFromCenter,
        west: mapMarker.lng - widthAwayFromCenter,
      };

      // Input
      const input = document.querySelector('.js-map-search-input');
      const options = {
        bounds: defaultBounds,
        componentRestrictions: {
          country: ['se', 'fi', 'no', 'dk', 'be'],
        },
        strictBounds: false,
      };

      const extraMarkers = [
        ...googleMap.querySelectorAll('.js-marker-locations'),
      ];

      const markerLocations = [];

      if (extraMarkers.length > 0) {
        // Gets and process data from HTML
        extraMarkers.forEach(extraMarker => {
          markerLocations.push({
            lat: parseFloat(extraMarker.dataset.lat),
            lng: parseFloat(extraMarker.dataset.lng),
            id: extraMarker.dataset.id,
          });
        });

        // Places markers on map
        markerLocations.forEach(markerLocation => {
          placeMarker(map, markerLocation);
        });
      }

      const autocomplete = new google.maps.places.Autocomplete(input, options);

      const zoomPoint = -29;

      autocomplete.addListener('place_changed', () => {
        const marker = new google.maps.Marker({
          map,
          anchorPoint: new google.maps.Point(0, zoomPoint),
        });

        marker.setVisible(false);

        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          return;
        }

        if (markerLocations.length > 0) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          let minDif = 99999;
          let closest = markerLocations[0];

          markerLocations.forEach(location => {
            const difference = calcPythagorasEquirectangular(
              lat,
              lng,
              location.lat,
              location.lng,
            );

            if (difference < minDif) {
              closest = location;
              minDif = difference;
            }
          });

          showHideMarkersAndLocations(closest.id);

          const zoomLevel = 17;
          map.setCenter({ lat: closest.lat, lng: closest.lng }, zoomLevel);
        }
      });
    });
  }
}

const DegToRad = deg => {
  const divider = 180;
  return (deg * Math.PI) / divider;
};

const calcPythagorasEquirectangular = (
  inputlat,
  inputLon,
  compareLat,
  compareLon,
) => {
  const convertedInputlat = DegToRad(inputlat);
  const convertedCompareLat = DegToRad(compareLat);
  const convertedInputLon = DegToRad(inputLon);
  const convertedCompareLon = DegToRad(compareLon);

  const radius = 6371; // km
  const half = 2;
  const firstSide =
    (convertedCompareLon - convertedInputLon) *
    Math.cos((convertedInputlat + convertedCompareLat) / half);
  const secondSide = convertedCompareLat - convertedInputlat;
  const difference =
    Math.sqrt(firstSide * firstSide + secondSide * secondSide) * radius;

  return difference;
};

const showHideMarkersAndLocations = id => {
  locations.forEach((location, index) => {
    if (location.id == id) {
      location.classList.remove('d-none');
      markers[index].setIcon('/Static/images/svg/icon-marker.svg');
    } else {
      location.classList.add('d-none');
      markers[index]?.setIcon('/Static/images/svg/icon-marker-black.svg');
    }
  });
};

const placeMarker = (map, loc) => {
  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(loc.lat, loc.lng),
    map: map,
    id: loc.id,
    icon: '/Static/images/svg/icon-marker-black.svg',
  });
  markers.push(marker);

  google.maps.event.addListener(marker, 'click', function (e) {
    showHideMarkersAndLocations(marker.id);
  });
};

const loadAPI = () => {
  if (
    typeof google == 'undefined' ||
    typeof google.maps == 'undefined' ||
    typeof google.maps.Map == 'undefined'
  ) {
    let tag = document.createElement('script');
    let googleMap = document.querySelector(googleMapsSelector);

    tag.src = API + googleMap.dataset.key + libraries;

    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
};
